import React from 'react';
import classnames from 'classnames';
import { Bubble } from 'tea-component';
import SvgIcon from '@/pages/home/components/SvgIcon';
import type { IBaseProps } from '@/pages/intelligence/types/common';
import './index.scss';

interface IAddBtnProps extends IBaseProps {
  disabled?: boolean;
  text?: string;
  disabledTips?: string;
  onClick?: (e: React.SyntheticEvent<HTMLDivElement>) => void;
}

export default function AddBtn(props: IAddBtnProps) {
  const { disabled = false, text, disabledTips, onClick, className, style } = props;

  const handleClick = (e: React.SyntheticEvent<HTMLDivElement>) => {
    e?.stopPropagation();
    e?.preventDefault();
    if (disabled) return;
    onClick?.(e);
  };

  return (
    <Bubble
      arrowPointAtCenter
      dark
      style={{ maxWidth: 'unset' }}
      placement="top"
      content={disabled ? disabledTips : undefined}
    >
      <div style={style} className={classnames('dbi-add-btn-container', className, { disabled })} onClick={handleClick}>
        <div className="dbi-add-btn">
          <SvgIcon type="cross" className="dbi-add-btn_con" />
        </div>
        {text && <span className="dbi-add-btn_text">{text}</span>}
      </div>
    </Bubble>
  );
}
